import React, { useState } from "react";
import { ASSETS } from "../../utils/config";

/**
 * stgport-avatar-wheel-fallback-mini-iyuga-logo: staging port of dev
 * PR#5296. `hasImage` excludes the backend's own no-portrait default
 * (`UserProfile.profile_image`'s DB default, the same URL as
 * `ASSETS.userPlaceholder`) — a truthy, loadable URL that isn't a real
 * portrait — and a dead photo URL swaps to the same fallback via onError,
 * so a no-portrait avatar always shows the mini iYuga logo
 * (`ASSETS.wheelLogoFallback`) instead of the near-invisible grey
 * silhouette or a broken-image glyph.
 */
export default function UserImage({ image, size = 45, style, onClick }) {
  const hasImage = Boolean(image) && image !== ASSETS.userPlaceholder;
  const [failed, setFailed] = useState(false);
  const showFallback = !hasImage || failed;

  return (
    <div
      data-testid="user-image-frame"
      onClick={onClick}
      style={{
        backgroundImage: `url(${ASSETS.backgroundWheelProfile})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        width: size,
        height: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: size * 0.1,
        ...style,
      }}
    >
      <img
        alt="us"
        data-testid={showFallback ? "avatar-wheel-fallback-logo" : undefined}
        src={showFallback ? ASSETS.wheelLogoFallback : image}
        onError={() => setFailed(true)}
        style={{
          width: "100%",
          height: "100%",
          border: "1px solid white",
          borderRadius: "50%",
          backgroundColor: "white",
        }}
      />
    </div>
  );
}
